import React, {useEffect, useState} from 'react';
import DeviceIdentifier from '../DeviceIdentifier';

const DebugInfo = ({ 
  queryParams = {}, 
  gameState = {}, 
  showToast = () => {},
  showSuccess = () => {},
  showError = () => {},
  showWarning = () => {},
  showInfo = () => {}
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  useEffect(() => {
    setIsVisible(process.env.NODE_ENV === 'development');
    setIsMinimized(true);
  }, []);

  if (!isVisible) return null;

  if (isMinimized) {
    return (
      <div 
        className="debug-panel minimized" 
        style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          background: 'rgba(0,0,0,0.8)',
          color: 'white',
          padding: '5px 10px',
          borderRadius: '20px',
          fontSize: '12px',
          zIndex: 9998,
          cursor: 'pointer'
        }}
        onClick={() => setIsMinimized(false)}
      >
        🔍 Debug
      </div>
    );
  }

  return (
    <div className="debug-panel" style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      background: 'rgba(0,0,0,0.9)',
      color: 'white',
      padding: '15px',
      borderRadius: '10px',
      fontSize: '12px',
      zIndex: 9998,
      maxWidth: '400px',
      maxHeight: '80vh',
      overflow: 'auto',
      boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
    }}>
      <div style={{
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '10px',
        borderBottom: '1px solid rgba(255,255,255,0.2)',
        paddingBottom: '5px'
      }}>
        <strong>🔍 Debug Panel</strong>
        <div>
          <button 
            onClick={() => setIsMinimized(true)}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              padding: '2px 6px',
              borderRadius: '3px',
              cursor: 'pointer',
              fontSize: '10px',
              marginRight: '5px'
            }}
          >
            ➖
          </button>
          <button 
            onClick={() => setIsVisible(false)}
            style={{
              background: 'rgba(255,0,0,0.6)',
              border: 'none',
              color: 'white',
              padding: '2px 6px',
              borderRadius: '3px',
              cursor: 'pointer',
              fontSize: '10px'
            }}
          >
            ✕
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '15px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>🔍 Query Params:</div>
        <pre style={{ 
          background: 'rgba(255,255,255,0.1)', 
          padding: '8px', 
          borderRadius: '5px',
          fontSize: '10px',
          overflow: 'auto',
          maxHeight: '100px'
        }}>
          {JSON.stringify(queryParams, null, 2)}
        </pre>
      </div>

      <div style={{ marginBottom: '15px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>🎮 Game State:</div>
        <pre style={{ 
          fontSize: '10px',
          background: 'rgba(255,255,255,0.1)', 
          padding: '8px', 
          borderRadius: '5px'
        }}>
          Grupy: {gameState.players?.length || 0} | 
          Dołki: {gameState.holes?.length || 0} | 
          Awatary: {gameState.availableAvatars?.length || 0}
        </pre>
      </div>

      <div style={{ marginBottom: '15px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>🍞 Toast Tests:</div>
        <div style={{ 
          display: 'flex', 
          gap: '5px', 
          flexWrap: 'wrap' 
        }}>
          <button 
            onClick={() => showSuccess('Test sukces!')} 
            style={{ 
              fontSize: '10px', 
              padding: '5px 8px',
              background: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            ✅ Success
          </button>
          <button 
            onClick={() => showError('Test błąd!')} 
            style={{ 
              fontSize: '10px', 
              padding: '5px 8px',
              background: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            ❌ Error
          </button>
          <button 
            onClick={() => showWarning('Test ostrzeżenie!')} 
            style={{ 
              fontSize: '10px', 
              padding: '5px 8px',
              background: '#ffc107',
              color: 'black',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            ⚠️ Warning
          </button>
          <button 
            onClick={() => showInfo('Test info!')} 
            style={{ 
              fontSize: '10px', 
              padding: '5px 8px',
              background: '#17a2b8',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            ℹ️ Info
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>📱 Device Info:</div>
        <div style={{ 
          background: 'rgba(255,255,255,0.1)', 
          padding: '8px', 
          borderRadius: '5px'
        }}>
          <DeviceIdentifier />
        </div>
      </div>

      <div style={{ marginBottom: '10px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>🔗 Quick Links:</div>
        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
          <button
            onClick={() => window.location.href = '/?viewId=admin'}
            style={{
              fontSize: '10px',
              padding: '3px 6px',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            Admin
          </button>
          <button
            onClick={() => window.location.href = '/?viewId=game'}
            style={{
              fontSize: '10px',
              padding: '3px 6px',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            Game
          </button>
          <button
            onClick={() => window.location.href = '/?viewId=leaderboard'}
            style={{
              fontSize: '10px',
              padding: '3px 6px',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            Leaderboard
          </button>
          <button
            onClick={() => window.location.reload()}
            style={{
              fontSize: '10px',
              padding: '3px 6px',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            🔄 Reload
          </button>
        </div>
      </div>
    </div>
  );
};

export default DebugInfo;